import { ProjectsCommand } from "./commands/ProjectsCommand.js";
import { BlogCommand } from "./commands/BlogCommand.js";
import { ManCommand } from "./commands/ManCommand.js";
import { HelpCommand } from "./commands/HelpCommand.js";
import { PwdCommand } from "./commands/PwdCommand.js";
import { ClearCommand } from "./commands/ClearCommand.js";
import { ExitCommand } from "./commands/ExitCommand.js";
import { LsCommand } from "./commands/LsCommand.js";
import { CdCommand } from "./commands/CdCommand.js";
import { CatCommand } from "./commands/CatCommand.js";
import { AboutCommand, ContactCommand } from "./commands/ContentCommands.js";
import { DateCommand, UnameCommand, ThemesCommand,
     FortuneCommand, EchoCommand, SudoCommand } from "./commands/SystemUtilityCommands.js";
import { HomeCommand } from "./commands/NavigationCommand.js";
import { AskCommand, ThemeCommand } from "./commands/SpecialtyCommands.js";

export class CommandRegistry {
    constructor(kernel) {
        this.kernel = kernel;
        this.commands = new Map();
        this.registerDefaults();
    }

    registerDefaults() {
        this.register('projects', new ProjectsCommand(this.kernel));
        this.register('blog', new BlogCommand(this.kernel));
        this.register('pwd', new PwdCommand(this.kernel));
        this.register('clear', new ClearCommand(this.kernel));
        this.register('exit', new ExitCommand(this.kernel));
        this.register('man', new ManCommand(this.kernel));
        this.register('help', new HelpCommand(this.kernel));
        this.register('ls', new LsCommand(this.kernel));
        this.register('cd', new CdCommand(this.kernel));
        this.register('cat', new CatCommand(this.kernel));
        this.register('about', new AboutCommand(this.kernel));
        this.register('whoami', new AboutCommand(this.kernel)); // Alias
        this.register('contact', new ContactCommand(this.kernel));
        this.register('date', new DateCommand(this.kernel));
        this.register('uname', new UnameCommand(this.kernel));
        this.register('themes', new ThemesCommand(this.kernel));
        this.register('fortune', new FortuneCommand(this.kernel));
        this.register('echo', new EchoCommand(this.kernel));
        this.register('sudo', new SudoCommand(this.kernel));
        this.register('home', new HomeCommand(this.kernel));
        this.register('ask', new AskCommand(this.kernel));
        this.register('theme', new ThemeCommand(this.kernel));
    }

    register(name, commandInstance) {
        this.commands.set(name, commandInstance);
    }

    get(commandName) {
        return this.commands.get(commandName);
    }
}
